<template>
      <Window  :defaultShow="shows" title="新增" @onClose="onClose">  
            <div style="margin:10px;height:350px;">
              <el-form ref="formPanelContent" :rules="formRules" :model="formData" size="mini" >
                   <div class="form-panel flex">
                        <div v-for="(item,index) in iFormItems"  class="form-panel-column-30" :key="index">
                                <div class="flex-nowrap">
                                    <span class="txt">{{item.title}}</span>  
                                    <el-input :class="{'activeErr':item.isActive}" v-if="item.type=='text'" type="text" :readonly=item.readonly :placeholder=item.hintTxt v-model="$data.formData[item.field]" size="small" :maxlength=item.maxlength show-word-limit></el-input>
                                    <el-switch v-if="item.type=='switch'" v-model="$data.formData[item.field]" :readonly=item.readonly></el-switch>
                                    <el-date-picker v-if="item.type=='date'"  v-model="$data.formData[item.field]" :readonly=item.readonly type="date" :placeholder=item.hintTxt size="small"></el-date-picker>
                                    <CompanyEyeInput  v-if="item.type=='company'" v-model="$data.formData[item.field]"  windowToBody size="small" @onEyeChange="onEyeChange"></CompanyEyeInput>                                    
                                    <InventoryEyeInput  v-if="item.type=='inventory'" v-model="$data.formData[item.field]"  windowToBody size="small" @onEyeChange="onEyeChange"></InventoryEyeInput> 
                                </div>
                                <div v-if="item.validateState === 'error' && item && item.serveMsg" style="margin-left:27%;font-size:12px;color:#f56c6c;margin-top:4px">{{item.serveMsg}}</div>                                                                                                                    
                        </div>
                    </div>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer" style="margin:5px;">
                <el-button  @click="onCancel">取 消</el-button>
                <el-button type="primary" @click="onSubmit">确 定</el-button>
        </div>
    </Window>
</template>

<script>
import Window from 'components/window/Window.vue'
import CompanyEyeInput from 'busicomponent/input/company/CompanyEyeInput.vue'
import FactoryEyeInput from 'busicomponent/input/company/FactoryEyeInput.vue'
import InventoryEyeInput from 'busicomponent/input/company/InventoryEyeInput.vue'
import SaleOrgService from '../service/SaleOrgService.js'


const FormPanelData={
    formItems:[
        // {title:"销售组织码:",hintTxt:"请输入销售组织",field:"saleOrgCode",maxlength:35,class:"form-panel-column-30",type:"text",serveMsg:"23"},
        {title:"公司:",field:"companyName",maxlength:35,class:"form-panel-column-30",type:"text",readonly:true},    
        {title:"工厂:",field:"factoryDesc",maxlength:35,class:"form-panel-column-30",type:"text",readonly:true},      
        {title:"库存地:",hintTxt:"请输入库存地",field:"inventoryDesc",maxlength:35,class:"form-panel-column-30",type:"inventory"},
        {title:"销售组织码:",hintTxt:"请输入销售组织",field:"saleOrgCode",maxlength:35,class:"form-panel-column-30",type:"text"},
        {title:"销售组织名:",hintTxt:"请输入销售组织名",field:"saleOrgDesc",maxlength:35,class:"form-panel-column-30",type:"text"},
        {title:"线上订单自动转:",field:"onlineOrderAutoSync",maxlength:35,class:"form-panel-column-30",type:"switch",readonly:true},        
        {title:"店铺ID:",hintTxt:"请输入店铺ID",field:"shopCode",maxlength:35,class:"form-panel-column-30",type:"text"},
        {title:"店铺名:",hintTxt:"请输入店铺名",field:"shopDesc",maxlength:35,class:"form-panel-column-30",type:"text"},
        {title:"所属平台:",hintTxt:"请输入所属平台",field:"belongPlatform",maxlength:35,class:"form-panel-column-30",type:"text"}
   ],
   formRules: {
        saleOrgCode:[{required: true,message: "请输入物料描述",trigger: "blur"}],
        saleOrgName:[{required: true,message: '',trigger: 'change'}]
   },
   //formData:{}
}
export default {
    components:{
       Window,CompanyEyeInput,FactoryEyeInput,
       InventoryEyeInput
    },
    props:{
      visible:Boolean,
      formItems:{
           Type:Array,
           default(){
               return FormPanelData.formItems;
           }
       },
       OperateType:{
           Type:String,
           default(){
               return "new"
           }
       }
    },
    
    watch:{
         visible(newVal,oldVal){           
            if(newVal){
                this.resetValidate()
            }
            this.shows=newVal;
         },
         OperateType(newVal,oldVal){
              this.iOperateType=newVal;
         }
    },
    data(){
        return {
            serveString:'',
            shows:this.visible,
            itype:this.type,
            formRules:FormPanelData.formRules,
            iFormItems:this.formItems,
            formData:{
              saleOrgCode:'',
              saleOrgName:'',
              companyId:'',
              companyCode:'',
              companyName:'',
            }
        }
    },
    methods:{
        ...SaleOrgService,
        onClose(status){
           this.shows=status;
           this.$emit("onClose",this.shows);
        },
        onEyeChange(inventoryRow){
            let vm=this;
            debugger;
           if(inventoryRow){
               vm.formData.companyId=inventoryRow.companyId;
               vm.formData.companyCode=inventoryRow.companyCode;
               vm.formData.companyName=inventoryRow.companyName;
               vm.formData.factoryId=inventoryRow.factoryId; 
               vm.formData.factoryCode=inventoryRow.factoryCode; 
               vm.formData.factoryDesc=inventoryRow.factoryDesc; 
               vm.formData.inventoryId=inventoryRow.inventoryId;              
               vm.formData.inventoryCode=inventoryRow.inventoryCode;              
               vm.formData.inventoryDesc=inventoryRow.inventoryDesc;              
           }
        },
        /**
         * 取消
         */
        onCancel(){
           let vm=this;
           vm.formData={};
           vm.onClose(false);
        },
        /**
         * 提交数据
         */
        onSubmit(){
            debugger;
            let vm=this;
            //窗体操作类型
            if(vm.iOperateType=="new"){
               this.newSaleOrg();
            }else{
               this.editSaleOrg();
            }            
        },
        newSaleOrg(){
            let vm=this,saleOrgForm=vm.formData;
            vm.submitSaleOrgan(saleOrgForm,function(resResult){ 
                console.log(resResult);   
                if(resResult){
                    if(resResult.errorFields){
                      vm.validate(resResult.errorFields);
                    }else{
                      vm.$emit("onSuccess",resResult.data);
                      vm.formData={}
                    }
                }
            });
        },
        editSaleOrg(){
            let vm=this,saleOrgForm=vm.formData;
            vm.editSaleOrgan(saleOrgForm,function(resResult){ 
                if(resResult){  
                  if(resResult.errorFields){
                       if(resResult.msg!=null&&resResult.msg!=undefined){
                           vm.$message.error(resResult.msg); 
                       }
                       vm.validate(resResult.errorFields);                   
                  }else{
                      vm.resetValidate();
                      vm.$emit("onSuccess",resResult.data);
                  }
                }
            });
        },
        /**
         * 加载编辑数据
         */
        loadEditData(editData){
            let vm=this; 
            vm.resetValidate();         
            vm.formData= JSON.parse(JSON.stringify(editData)) ;           
        },
        validate(errorFields){
            if(!errorFields){
                return;
            }
            let vm=this;
            let error={};
            errorFields.forEach(item=>{
                error[item.errorField]=item.errorDesc;
            });
            vm.serveString='';
            vm.iFormItems.forEach(item=>{
                vm.serveString=vm.serveString+item.serveMsg;
                if(error[item.field]){
                    item.validateState='error';
                    item.serveMsg='';
                    item.serveMsg=error[item.field];
                    item.isActive=true;
                }else{
                   item.validateState='';
                   item.serveMsg='';
                   item.isActive=false; 
                }
            });
            vm.iFormItems = JSON.parse(JSON.stringify(vm.iFormItems));
        },
        resetValidate(){       
            let vm=this;     
            vm.formItems.forEach(item=>{
                  item.validateState='';
                  item.serveMsg='';
                  item.isActive=false; 
            });
        }
    }
    
}
</script>
<style>
    .activeErr .el-input__inner{
        border-color: #f56c6c;
    }
</style>